import React from "react";
import { useAuth } from "../contexts/AuthContext";
import AccessDenied from "../pages/AccessDenied";
import UpgradePlan from "../pages/UpgradePlan";
import AppLayout from "../AppLayout";

/**
 * ProtectedRoute supports:
 * - module + feature access
 * - role access
 * - requireAll
 * - upgrade plan fallback
 */

const ProtectedRoute = ({
  children,
  roles = [],
  module = null,
  feature = null,
  requireAll = false,
  fallback = "access-denied",
  customFallback = null,
}) => {
  const { canAccess } = useAuth();

  const allowed = canAccess({
    module,
    feature,
    roles,
    requireAll,
  });

  if (!allowed) {
    // If user supplied a custom fallback component
    if (customFallback) {
      return <AppLayout>{customFallback}</AppLayout>;
    }

    // Plan upgrade fallback
    if (fallback === "upgrade-plan") {
      return (
        <AppLayout>
          <UpgradePlan />
        </AppLayout>
      );
    }

    // Default: Access denied
    return (
      <AppLayout>
        <AccessDenied />
      </AppLayout>
    );
  }

  return children;
};

export default ProtectedRoute;
